export type Service = {
  title: string
  description: string
  cta: string
  image: string
  alt: string
  background: string
  text: string
  buttonBg: string
  buttonText: string
}

export const services: Service[] = [
  {
    title: 'Branding',
    description:
      'Identity systems, logos, and guidelines that hold up everywhere they land — online, in print, and on the street.',
    cta: 'Build brand identity',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/34dbd326-69e1-4c2c-a6a3-90a4a134f3a4.jpg',
    alt: 'Brand identity presentation board with logo cards, colour palette and tote bag mockup',
    background: '#0000FE',
    text: '#FFFFFF',
    buttonBg: '#FFFFFF',
    buttonText: '#2E2E2E',
  },
  {
    title: 'Web design & build',
    description:
      'Sites that load fast, read clearly, and turn visitors into customers. Designed and developed by the same small team.',
    cta: 'Design website today',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6e07eb62-69dd-478d-a3c2-93ba1a303789.jpg',
    alt: 'Desktop monitor showing a modern website layout',
    background: '#FFFFFF',
    text: '#2D2D2D',
    buttonBg: '#0000FE',
    buttonText: '#FFFFFF',
  },
  {
    title: 'Marketing',
    description:
      'Launches, social, and content that actually move the numbers you care about — not just the ones that look good in a deck.',
    cta: 'Plan a campaign',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2b095582-4123-49bd-b78c-7d4abf6398bd.jpg',
    alt: 'Printed campaign posters, a brochure and a phone showing a social media grid',
    background: '#E2FBFF',
    text: '#2D2D2D',
    buttonBg: '#0000FE',
    buttonText: '#FFFFFF',
  },
  {
    title: 'Creative consulting',
    description:
      "Direction, positioning, and design strategy when you need an outside perspective that's been here before.",
    cta: 'Talk strategy',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e663636d-f12e-4aae-aca4-e7b349a39690.jpg',
    alt: 'Design strategy workshop table with wireframe sketches, sticky notes and a notebook',
    background: '#E36F2B',
    text: '#FFFFFF',
    buttonBg: '#FFFFFF',
    buttonText: '#2E2E2E',
  },
]
